import { Box, FormHelperText, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DetailSelect } from '~/components/forms/details';
import { NumberInput } from '~/components/inputs';
import type { EventValue } from '../../lib/utils';

export interface EventOffsetProps {
  error?: boolean;
  eventName: EventValue | null;
  helperText?: string;
  onChange: (value: number | null) => void;
  value: number | null;
}

export const EventOffset = ({
  error,
  eventName,
  helperText,
  onChange,
  value,
}: EventOffsetProps) => {
  const { t } = useTranslation();
  const [direction, setDirection] = useState<'Before' | 'After'>(() => {
    if (
      eventName === 'NFL_END_TIME' ||
      eventName === 'MLB_END_GAME' ||
      eventName === 'NHL_END_GAME'
    )
      return 'After';
    return Number(value) < 0 ? 'Before' : 'After';
  });

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-start' }}>
        <Box>
          <NumberInput
            error={error}
            hideDecrement
            hideIncrement
            min={0}
            onChange={(_, value) => {
              if (!value) return onChange(value);
              onChange(direction === 'Before' ? -value : value);
            }}
            value={Math.abs(value ?? 0)}
            InputProps={{ error, inputPadding: '16.5px', inputWidth: '70px' }}
          />
        </Box>
        <Box sx={{ mt: 2 }}>{t('common.time.minutes')}</Box>
        <DetailSelect
          formControlProps={{ sx: { flexBasis: '30%' } }}
          value={direction}
          onChange={(event) => {
            if (event.target.value !== 'Before' && event.target.value !== 'After') return;
            setDirection(event.target.value);
            if (
              eventName === 'COMMON_START_TIME' &&
              event.target.value === 'After' &&
              Number(value) < -15
            ) {
              onChange(0);
            }
            onChange(value ? value * -1 : null);
          }}
        >
          {['Before', 'After'].map((value, index) => (
            <MenuItem
              disabled={
                (eventName === 'NFL_END_TIME' ||
                  eventName === 'MLB_END_GAME' ||
                  eventName === 'NHL_END_GAME') &&
                value === 'Before'
              }
              key={index}
              value={value}
            >
              {value === 'Before'
                ? t('pages.device_signals.settings.event_offset.before')
                : t('pages.device_signals.settings.event_offset.after')}
            </MenuItem>
          ))}
        </DetailSelect>
      </Box>
      <FormHelperText sx={{ color: 'error.dark' }}>{helperText}</FormHelperText>
    </Box>
  );
};
